export default __webpack_public_path__ + "static/media/dt_dance.a036e466.mp3";